import { useState, useEffect } from "react";
import { Box, Grid, Tab } from "@mui/material";
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUnitAndEnumSingleData, getUnitsAndEnumsLoading } from '../selector/selectors';
import {  loadUnitAndEnumEditData } from "../api/unitsandenumsapi";
import LoaderComponent from "../components/LoaderComponent";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import UnitEnumsGrid from "../components/UnitEnumsGrid";


const EditUnitsAndEnums = ({
    isLoading,
    unitAndEnumData,
    loadUnitAndEnumEditData
}) => {
    const params                            =   useParams();
    const [value, setValue]                 =   useState('1');

    useEffect(() => {
       loadUnitAndEnumEditData(params.id);
    }, [loadUnitAndEnumEditData,params.id]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
    <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
            <TabContext value={value}>
                <Grid item xs={12} md={12} lg={12} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="">
                            <Tab label="Edit Units Data" value="1" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{p:0,pt:2}}>
                        {unitAndEnumData.length > 0 &&
                            <UnitEnumsGrid
                                result={unitAndEnumData}
                            />
                        }
                    </TabPanel>
                </Grid>
            </TabContext>
        
      

        
        </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
    isLoading: getUnitsAndEnumsLoading(state),  
    unitAndEnumData:getUnitAndEnumSingleData(state)
});
const mapDispatchToProps = (dispatch) => ({
    loadUnitAndEnumEditData:(id)      => dispatch(loadUnitAndEnumEditData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUnitsAndEnums); 